import React from "react";
import MaskRightImg from "../../../assets/images/DietPlans/Mask-right-img.png";

import Weightloss from "../../../assets/images/DietPlans/Weightloss.png";
import PreDiabetes from "../../../assets/images/DietPlans/PreDiabetes.png";
import Hypertension from "../../../assets/images/DietPlans/Hypertension.png";
import MuscleGain from "../../../assets/images/DietPlans/MuscleGain.png";
import Thyroid from "../../../assets/images/DietPlans/Thyroid.png";
import PCOD from "../../../assets/images/DietPlans/PCOD.png";
import Diabetes from "../../../assets/images/DietPlans/Diabetes.png";
import ProElitePlanImg from "../../../assets/images/DietPlans/pro_elite_plan.png"
import { PlanType } from "../../../constants";

const dietPlans = {
  weight_loss: "Weight loss",
  pre_diabetes: "Pre diabetes",
  muscle_gain: "Muscle gain",
  diabetes: "Diabetes",
  hypertension: "Hypertension",
  pcod: "PCOD",
  thyroid: "Thyroid",
};

const ProDietPlanCard = ({ dietPlan }) => {
  let dietPlanType = dietPlan?.assessmentDetails?.planType;
  if (dietPlanType) dietPlanType = dietPlans?.[dietPlanType];

  const getPlanImage = (type) => {
    switch (type) {
      case "weight_loss":
        return Weightloss;
      case "pre_diabetes":
        return PreDiabetes;
      case "muscle_gain":
        return MuscleGain;
      case "diabetes":
        return Diabetes;
      case "hypertension":
        return Hypertension;
      case "pcod":
        return PCOD;
      case "thyroid":
        return Thyroid;
      default:
    }
  };

  function formatDateToCustom(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const suffix =
      day === 1 || day === 21 || day === 31
        ? "st"
        : day === 2 || day === 22
        ? "nd"
        : day === 3 || day === 23
        ? "rd"
        : "th";
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}${suffix} ${month} ${year}`;
  }

  return (
    <>  
      {/* <h2 className="payment-title-dark">
        MEMBER TILL {formatDateToCustom(dietPlan?.planEndDate)}
      </h2> */}
      <label className="payment-card-pro">
        <div className="payment-card-pro-sub d-flex flex-row align-items-center">
          <img
            className="plan-type-img"
            src={(dietPlan?.planType !== PlanType.ELITE_PLAN && dietPlan?.planType !== PlanType.AIPLAN)
              ? getPlanImage(dietPlan?.assessmentDetails?.planType)
              : ProElitePlanImg }
            alt=""
            loading="lazy"
          />
          <div>
            <span className="card-title">
            {(dietPlan?.planType === PlanType.ELITE_PLAN)
                ? "PRO LITE PLAN"
                : (dietPlan?.planType === PlanType.AIPLAN)
                ? "GENERATED AI DIET PLAN"
                : "DIET PLAN"
                }
            </span>
            <div className="card-subtitle">
              <span style={{ fontWeight: 600 }}>{dietPlanType}</span>
              {dietPlanType && <span style={{ margin: "0  4px" }}> • </span>}
              <span>Active {formatDateToCustom(dietPlan?.planEndDate)}</span>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row">
          <div className="payment-imageRightArrow-">
            <img
              src={MaskRightImg}
              alt="logo"
              loading="lazy"
            />
          </div>
        </div>
      </label>
    </>
  );
};

export default ProDietPlanCard;
